<template>

<v-dialog v-model="dialog" width="700px">
  <v-card>
    <v-card-title>Set payment orders to 'New'</v-card-title>
    <v-container fluid>
   

    </v-container>
  
     <v-card-actions>  
       <v-spacer></v-spacer>
           <!-- <v-btn class="primary mx-2" small @click="saveHsfp">Save</v-btn> -->
           <v-btn color="primary"  small @click="close()">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      btod: {},
    }
  },
  methods: {
    open(btod_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/task/fin/abn/btodToNew.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "btodToNew"
          },
          btodToNew: {
            btod_encrid: btod_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.btod = res.data.btodToNew;
            
            /* this.dialog = false; */
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
      this.$router.reload('/task/fin/abn/searchBtodExported'); 
    }
  }
}
</script>

